import type { ReactNode } from 'react'
import { Outlet } from 'react-router'
import { NotFoundView } from '#src/components/NotFoundView.js'
import { getClients, getSeoData } from '#src/data/data.js'
import { languageService } from '#src/languageService.js'
import { getPortfolioPageBySlug } from '#src/pages/portfolio/portfolioData.js'
import { mergeMeta, noindexUnlessTranslated, seoTagsToMeta } from '#src/seo.js'
import type { Route } from './+types/portfolio-page.route.js'
import { Portfolio } from './Portfolio.js'

export async function loader({ request, params }: Route.LoaderArgs) {
  const { portfolioPageSlug } = params
  const lang = languageService.langFromRequest(request)
  const [data, clients, seoData] = await Promise.all([
    getPortfolioPageBySlug(portfolioPageSlug, lang),
    getClients(),
    getSeoData('portfolioPage', lang, `{slug: {eq: "${portfolioPageSlug}"}}`),
  ])

  const meta = [
    ...seoTagsToMeta(seoData.page?.seo),
    ...noindexUnlessTranslated(`/portfolio/${portfolioPageSlug}`, lang),
  ]
  return { data, clients, meta }
}

export function meta({ loaderData, matches }: Route.MetaArgs): Route.MetaDescriptors {
  return mergeMeta(matches[0].meta, loaderData?.meta || [])
}

export default function PortfolioPageLayout({ loaderData }: Route.ComponentProps): ReactNode {
  if (!loaderData.data) {
    return <NotFoundView />
  }

  return (
    <Portfolio data={loaderData.data} clients={loaderData.clients}>
      <Outlet />
    </Portfolio>
  )
}
